<template>
	<router-view></router-view>
</template>

<script>
export default {
	name: 'states',
};
</script>



// WEBPACK FOOTER //
// States.vue?205bc1e0